import type { ErrorRegistryShape } from '../common/common.error';

export const PORTFOLIO_MEMO_ERROR = {
  NOT_FOUND_PORTFOLIO_MEMO: { status: 404, message: 'Portfolio memo not found' },
  /** 메모는 쓴 사람만 고치고 지운다 */
  FORBIDDEN_NOT_MEMO_AUTHOR: { status: 403, message: 'Only the author can change this memo' },
} as const satisfies ErrorRegistryShape;
